export function matchOverviewStatus(status, visitor) {
    switch(status){
        case 'active':
            return visitor.active();
        case 'paymentConnected':
            return visitor.paymentConnected();
        case 'reviewed':
            return visitor.reviewed();
        case 'sent':
            return visitor.sent();
        case 'scheduled':
            return visitor.scheduled();
        case 'draft':
            return visitor.draft();
    }
}
const kept = ()=>false;
const withdrawn = ()=>true;
const isWithdrawnOnArchive = (status)=>matchOverviewStatus(status, {
        active: kept,
        paymentConnected: withdrawn,
        reviewed: withdrawn,
        sent: withdrawn,
        scheduled: withdrawn,
        draft: withdrawn
    });
export const dropWithdrawnAgreements = (items)=>items === null || items === void 0 ? void 0 : items.filter((item)=>!isWithdrawnOnArchive(item.status));
